<template>
  <a-config-provider
    :theme="{
      algorithm: theme.defaultAlgorithm,
      token: {
        colorPrimary: '#11BA82',
      },
    }"
  >
    <div>
      <sale-banner />
      <navbar />
      <main>
        <router-view />
      </main>
      <footer-component />
    </div>
  </a-config-provider>
</template>

<script setup lang="ts">
import Navbar from '../components/Navbars/IndexNavbar.vue';
import SaleBanner from '../components/Banners/SaleBanner.vue';
import FooterComponent from '../components/Footers/FooterPrimary.vue';
import { theme } from 'ant-design-vue';
</script>
